module.exports = __webpack_public_path__ + "static/img/homeprd1.c187ed3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xh/images/homeprd1.png
// module id = NN1x
// module chunks = 8